import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skltn = (props) => {
    return (
        <div className="skltn-lotterydetails">
            <div className={`ItemDetail lottery-detailes`}>
                <div className="contain">
                    <div className="awardDetails">
                        <div className="backward">
                            <span>بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></span>
                        </div>
                        <div className="detailBody">
                            <div className="details">
                                <div className="title">
                                    <Skeleton animation="wave" width={81 + '%'} height={28} />
                                </div>
                                <h5>جزئیات قرعه کشی</h5>
                                <p>
                                    <Skeleton animation="wave" width={90 + '%'} height={20} />
                                    <Skeleton animation="wave" width={90 + '%'} height={20} />
                                    <Skeleton animation="wave" width={90 + '%'} height={20} />
                                </p>
                                <h5>جوایز برندگان</h5>
                                <Skeleton animation="wave" width={100} height={26} />
                                <Skeleton animation="wave" width={260} height={26} />
                                <Skeleton animation="wave" width={100} height={26} />
                                <Skeleton animation="wave" width={260} height={26} />
                                <Skeleton animation="wave" width={100} height={26} />
                                <Skeleton animation="wave" width={260} height={26} />
                            </div>
                            <div className="timer">
                                <div className="grades">
                                    <span>حداقل امتیاز : <b><Skeleton animation="wave" width={40} height={22} /></b></span>
                                    <span>امتیاز شما : <b><Skeleton animation="wave" width={40} height={22} /></b></span>
                                </div>
                                <div className="counter">
                                    <span>زمان باقی مانده تا قرعه کشی</span>
                                    <div className="timestamp">
                                        <div className="time">
                                            <Skeleton animation="wave" width={45} height={45} />
                                            <span>دقیقه</span>
                                        </div>
                                        <div className="time">
                                            <Skeleton animation="wave" width={45} height={45} />
                                            <span>ساعت</span>
                                        </div>
                                        <div className="time">
                                            <Skeleton animation="wave" width={45} height={45} />
                                            <span>روز</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-base btn-black btn-sircle">
                                    <Skeleton animation="wave" width={150} height={38} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Skltn;